<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import type { RecruitmentService } from "../../services/recruitment.service";
  import BlueButton from "../BlueButton.svelte";
  import RedButton from "../RedButton.svelte";

  export let service: RecruitmentService;
  export let klass = "";
  const prefectures = service.store.prefectures;
  const trainLinesByPrefecture = service.store.trainLinesByPrefecture;
  const stations = service.store.stations;
  const busStops = service.store.busStops;
  const means = service.store.meanOfTransportations;

  const model = service.store.model;
  const transportations = service.store.transportations;
  const trainLineAndStationMeans = ["電車", "徒歩", "車"];
</script>

<div class={klass}>アクセス</div>
<SectionBoard theme="blue" klass="mt-2">
  <BlueButton rounded click={service.addTransportation}>追加</BlueButton>

  <div class="mt-4">
    <FormWithLabel
      label="都道府県"
      input={service.handleTransportaionPrefecture}
      value={$model.transportationPrefecture}
      inputType="select"
      options={$prefectures}
    />
  </div>

  <div class="mt-4">
    {#each $transportations as t, i}
      <div class="flex items-end {i === 0 ? '' : 'mt-2'}">
        <div class="w-28">
          <FormWithLabel
            label="交通手段"
            input={service.handleMean(i)}
            value={$model.transportations[i].meanId}
            inputType="select"
            options={$means}
          />
        </div>

        {#each $means as m, j}
          {#if m.id === t.meanId}
            {#if trainLineAndStationMeans.includes(m.label)}
              <div class="ml-4 w-28">
                <FormWithLabel
                  label="路線"
                  input={service.handleTrainLine(i)}
                  value={$model.transportations[i].trainLineId}
                  inputType="select"
                  options={$trainLinesByPrefecture}
                />
              </div>

              {#if $stations[i] && $stations[i].length !== 0}
                <div class="ml-4 w-28">
                  <FormWithLabel
                    label="駅"
                    input={service.handleStation(i)}
                    value={$model.transportations[i].stationId}
                    inputType="select"
                    options={$stations[i]}
                  />
                </div>
              {/if}
            {/if}
          {:else if m.id === t.meanId && m.label === "バス"}
            <div class="ml-4 w-28">
              <FormWithLabel
                label="バス停"
                input={service.handleBusStop(i)}
                value={$model.transportations[i].busStopId}
                inputType="select"
                options={$busStops}
              />
            </div>
          {/if}
        {/each}

        <div class="ml-4 w-28">
          <FormWithLabel
            label="分"
            input={service.handleMinutes(i)}
            value={$model.transportations[i].minutes}
            inputType="number"
            min="0"
          />
        </div>

        <RedButton rounded click={service.removeTransportation(i)} klass="ml-4">
          削除
        </RedButton>
      </div>
    {/each}
  </div>
</SectionBoard>
